<template>
    <div class="bg-nomad-900 rounded-xl p-6 min-w-0">
        <h1 class="text-lg font-semibold text-white">Fix no audio</h1>
        <p class="mt-1 text-sm text-nomad-100">
            About <span class="font-semibold text-nomad-accent" v-if="content">{{ content.status }}</span>
            songs are without audio.
        </p>
        <div class="grid gap-1 mt-4" v-if="content">
            <h2 class="text-white font-semibold text-xl truncate">{{ content.song.name }}</h2>
            <h5 class="text-nomad-100 text-sm">{{ content.song.artist.name }}</h5>
            <h5 class="text-nomad-accent text-sm" v-if="content.song.youtube"><a :href="'https://youtu.be/'+content.song.youtube" target="_blank">{{ content.song.youtube }}</a></h5>
            <h5 class="text-nomad-300 text-sm">#{{ content.song.id }}</h5>
            <input type="text" class="w-full rounded-lg bg-nomad-800 border border-nomad-700 text-white placeholder:text-nomad-400 focus:border-nomad-accent focus:ring-nomad-accent mt-3" placeholder="YouTube ID" v-model="youtube" />
            <div class="flex gap-3 mt-3">
                <button class="shrink-0 rounded-lg bg-nomad-accent text-nomad-900 font-semibold px-4 h-11 hover:bg-nomad-accent/80" @click="saveYoutube">Save</button>
            <button class="rounded-lg bg-nomad-800 text-white font-medium px-4 h-11 hover:bg-nomad-700 icon-refresh-ccw" aria-label="Next song" @click="getNoAudio"></button>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { mapActions } from "vuex";
export default {
    data() {
        return {
            content: null,
            youtube:null
        }
    },
    created() {
        this.getNoAudio()
    },
    methods: {
        ...mapActions("notification", ["showNotification"]),
        getNoAudio() {
            axios.get('/api/backstage/no-audio')
                .then((response) => {
                    this.content = response.data
                })
        },
        saveYoutube() {
            axios.post('/api/backstage/save-youtube', {id: this.content.song.id, youtube: this.youtube})
                .then((response) => {
                    this.youtube = null
                    this.showNotification({
                        message: response.data.message,
                        type: 'info',
                    })
                })
                .catch(error => {
                    this.showNotification({
                        message: "error occurred",
                        type: 'warning',
                    })
                })
        }
    }
}
</script>